module.exports = __webpack_public_path__ + "img/ic_asset_verified.0609ef5f.png";